export default __webpack_public_path__ + "static/dahler-logo.23537f88.svg";